module.exports = __webpack_public_path__ + "static/media/account_circle.207dfd20.svg";